export const environment = {
  baseMyPAUrl: 'https://mypa-myp3.collaudo.regione.veneto.it/mypa/'
};
